import {EventFlowContainer} from './components/event-flow-container';

export default {
    component: EventFlowContainer
};
